import Cresta51 from './Cresta 5 (1).webp'
import Cresta52 from './Cresta 5 (2).webp'
import Cresta53 from './Cresta 5 (3).webp'
import Cresta54 from './Cresta 5 (4).webp'
import Cresta55 from './Cresta 5 (5).webp'
import Cresta56 from './Cresta 5 (6).webp'
import Cresta57 from './Cresta 5 (7).webp'
import Cresta58 from './Cresta 5 (8).webp'
import Cresta59 from './Cresta 5 (9).webp'
import Cresta510 from './Cresta 5 (10).webp'




const Cresta5images =[
Cresta51,Cresta52,Cresta53,Cresta54,Cresta55,Cresta56,Cresta57,Cresta58,Cresta59,Cresta510
]

export default Cresta5images;